<template>
    <div class="well" style="width: 100%;" scrolling="yes" v-html="preview">
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: Number,
            required: false,
            default: null
        }
    },
    data() {
        return {
            preview: ''
        }
    },
    watch: {
        id: function(val) {
            this.getPreview(val)
        }
    },
    created() {
        this.getPreview(this.id)
    },
    methods: {
        getPreview(mailId) {
            if (mailId) {
                this.$ajax.get('./?_f=emailFrame&custom', {id: mailId}, (data) => {
                    this.preview = data.message
                }, "json")
            }
            else this.preview = ""
        }
    }
}
</script>